<template>
    <div>
        <div class="update_data_btn">
            <Button type="primary" size="small" style="font-size: 13px;" @click="click_update_data('')">
                <Icon type="md-repeat" />更新市占数据
            </Button>
        </div>
        <div class="chart_div">
            <div id="chart1">

            </div>
        </div>

        <Modal v-model="add_show" title="更新市占数据" :mask-closable="false" :footer-hide="true" width="400">
            <div>
                <div style="font-size: 13px;background-color: orange;padding:3px 10px;margin-bottom: 10px;color:#fff">
                    提示：至少要有一条{{company_name_list}}的数据。
                </div>
                <div class="add_list" v-for="(item, i) in update_data">
                    <div class="bgs" v-if="company_name_list.indexOf(item.company_name) !=-1">我司</div>
                    <Input v-model="item.company_name" placeholder="请输入xx人力"
                        :style="company_name_list.indexOf(item.company_name) !=-1 ? 'width: 150px' : 'width: 220px'" />
                    <span style="margin:0 10px">-</span>
                    <InputNumber :max="100" :min="1" :step="0.1" v-model="item.percentage_count" />
                    <div>%</div>
                    <Icon type="ios-trash-outline" color="red" style="margin-left:10px;cursor: pointer;" size="20"
                        @click="del_item(i)" />
                </div>
                <div class="add_tonghang">
                    <Button type="primary" size="small" @click="add_new_item" style="font-size:13px"><Icon type="md-add" />添加一个同行</Button>
                    <span style="font-size: 13px;color:#ccc;">当前合计:{{ percentage_count_total() }}%</span>
                </div>

                <div class="urge_btn">
                    <Button type="primary" @click="confirm">确认更新</Button>
                </div>
            </div>
        </Modal>

    </div>
</template>

<script>
import * as echarts from 'echarts';
import { http, open_new_page } from "@/utils/http.js";

export default {
    name: 'project_market_share',
    data() {

        return {
            project_id: '',
            chart1: null,
            add_show: false,
            update_data: [
                {
                    company_name: '',
                    percentage_count: 100
                }
            ],
            company_name_list:['大湘人力','三汇人力']
        }
    },
    mounted() {

    },
    methods: {
        percentage_count_total(){
            var count = 0
            for(var i=0;i<this.update_data.length;i++){
                    count += this.update_data[i]['percentage_count']
            }
            return count
        },

        get_data() {
            var that = this;
            var obj = {
                project_id: this.project_id,
                data_list: this.update_data,
            };
            http(
                "post",
                process.env.VUE_APP_HOST + "/my_project/project_detail/market_share/get_market_share",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {

                        that.update_data = res.data.data_list
                        that.create_chart()

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },

        confirm() {
            var that = this;
            var obj = {
                project_id: this.project_id,
                data_list: this.update_data,
            };
            http(
                "post",
                process.env.VUE_APP_HOST + "/my_project/project_detail/market_share/update_market_share",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.add_show = false
                        that.create_chart()

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },

        del_item(index) {
            this.update_data.splice(index, 1)
        },

        add_new_item() {
            this.update_data.push({
                company_name: "", percentage_count: 1
            })
        },
        click_update_data(project_id) {
            if(project_id){
                console.log(project_id)
                this.project_id = project_id
            }
            this.add_show = true
        },

        open(project_id) {
            this.project_id = project_id

            this.get_data()
        },
        create_chart() {

            var chartDom = document.getElementById('chart1');
            this.chart1 = echarts.init(chartDom);

            var option;

            var data = []
            for (var i = 0; i < this.update_data.length; i++) {
                data.push({
                    'name': this.update_data[i]['company_name'],
                    'value': this.update_data[i]['percentage_count'],
                })
            }

            option = {
                title: {
                    text: '',
                    subtext: '',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left'
                },
                series: [
                    {
                        name: '所占比例(%)',
                        type: 'pie',
                        radius: '50%',
                        data: data,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };

            option && this.chart1.setOption(option);

        }
    }
}
</script>

<style scoped>
.add_tonghang{
    margin-top:10px;
    padding-top:10px;
    border-top:1px dashed #ededed;
    display: flex;
    justify-content: space-between;
}

.bgs {
    padding: 3px 5px;
    width: 60px;
    font-size: 13px;
    background-color: rgb(253, 52, 52);
    text-align: center;
    border-radius: 5px;
    color: #fff;
    margin-right: 10px;

}

.add_list {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}

.urge_btn {
    display: flex;
    justify-content: end;
    margin-top: 10px;
}

.update_data_btn {
    margin-top: 5px;
    display: flex;
    justify-content: end;
}

.chart_div {
    padding-left: 10px;
}

#chart1 {
    height: 200px;
    width: 600px;
    /* background-color: rgb(255, 217, 217); */
}
</style>